export const environment = {
  production: false,
  API_URL: 'https://dfwairportcustomerportalwebapi.azurewebsites.net',
  ENV: 'DEV',
};
